import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './slices';
import cartMiddleware from '../middlewares/cartMiddleware';
import handleStorageBrowser from '../helpers/handleStorageBrowser';
import { EP } from '../configs/constant';
import shopMiddleware from '../middlewares/shopMiddleware';
//Lấy dữ liệu trong localstorage
const persistedStateCart = handleStorageBrowser.getItemLocalStorage(EP.CART) || [];
const persistedStateShop = handleStorageBrowser.getItemLocalStorage(EP.SHOP) || [];
//Config store redux
export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(cartMiddleware, shopMiddleware),
    preloadedState: {
        cart: {
            cartInfo: persistedStateCart
        },
        shop: {
            shopInfo: persistedStateShop,
            isReady: false
        }
    },
    devTools: process.env.NODE_ENV !== 'production',
})
// store.subscribe(() => {
//     handleStorageBrowser.setItemLocalStorage(EP.CART, store.getState()); // Lưu trạng thái mới vào localStorage sau mỗi lần thay đổi
// });
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
export const getCartState = (state: RootState) => state.cart;
export const getCategoryState = (state: RootState) => state.category;
export const getUiState = (state: RootState) => state.ui;
export const getShopState = (state: RootState) => state.shop;
export const getProductState = (state: RootState) => state.product;
export const getOrderState = (state: RootState) => state.order;
export const getComboState = (state: RootState) => state.combo;